import React from 'react'
import { connect } from 'react-redux'
import styles from './Onboarding.scss'
import { Icon } from 'common/LegacyIcon'
import * as userActions from 'lib/api/currentUser'
import { intThatWraps } from 'lib/utils'
import { FormattedMessage as T, injectIntl, defineMessages } from 'react-intl'

const messages = defineMessages({
  title1: {
    id: 'Onboarding.title1',
    defaultMessage: 'Select text to add formatting and links'
  },
  title2: {
    id: 'Onboarding.title2',
    defaultMessage: 'Use the block toolbar to add maps , images, and galleries to your report'
  },
  title3: {
    id: 'Onboarding.title3',
    defaultMessage: 'Use the paragraph toolbar to add lists and headings'
  },
  title4: {
    id: 'Onboarding.title4',
    defaultMessage: 'Click on a map or photo to customize'
  }
})

const tips = [
  {
    title: messages.title1,
    demo: '/images/rr-onboarding/inline-styles.gif'
  },
  {
    title: messages.title2,
    demo: '/images/rr-onboarding/add-map.gif'
  },
  {
    title: messages.title3,
    demo: '/images/rr-onboarding/add-list.gif'
  },
  {
    title: messages.title4,
    demo: '/images/rr-onboarding/customize-map.gif'
  }
]

export class Onboarding extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeTip: intThatWraps(0, tips.length)
    }
  }

  next = () => this.setState({ activeTip: this.state.activeTip.next() })

  prev = () => this.setState({ activeTip: this.state.activeTip.prev() })

  render () {
    const { dismissed, onDismiss, intl } = this.props
    const activeIndex = this.state.activeTip.value
    const tip = tips[activeIndex]

    if (dismissed) {
      return null
    }

    return (
      <div className={styles.Onboarding}>
        <h2 className={styles.tipTitle}>{intl.formatMessage(tip.title)}</h2>
        <img src={tip.demo} key={tip.demo} />
        <p className={styles.dismissText} onClick={onDismiss}>
          <Icon i='x' size={10} alignMiddle={false} /> <T id='Onboarding.hideHints' defaultMessage='hide these hints' />
        </p>
        <div className={styles.prev} onClick={this.prev}>
          <Icon i='leftChevron' size={25} />
        </div>
        <div className={styles.next} onClick={this.next}>
          <Icon i='rightChevron' size={25} />
        </div>
        <div className={styles.dismiss} onClick={onDismiss}>
          <Icon i='x' size={16} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  dismissed: state.currentUser.preferences.get('rr-onboarding-dismissed', false)
})

const mapDispatchToProps = (dispatch) => ({
  onDismiss: () => dispatch(userActions.setPreference('rr-onboarding-dismissed', true))
})

export const OnboardingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Onboarding))
